import { render } from "./PosLogin.vue?vue&type=template&id=fdeb5e16"
import script from "./PosLogin.vue?vue&type=script&lang=js"
export * from "./PosLogin.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\php\\POS-SYSTEM-BACKUP-STRIPE\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__